import { render, staticRenderFns } from "./ConsultaExpediente.vue?vue&type=template&id=69709ae2"
import script from "./ConsultaExpediente.vue?vue&type=script&lang=js"
export * from "./ConsultaExpediente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports